export const PRODUCT_CONFIRMATION_HTML_TOKEN = "{{productConfirmationHTML}}";

const purchasedProductIds = (products) => new Set(
    Object.entries(products || {})
        .filter(([, product]) => product?.quantity === undefined || Number(product.quantity) > 0)
        .map(([productId]) => productId.toString())
);

const findPurchasedProductConfirmationHTML = (pages, products) => {
    const purchasedIds = purchasedProductIds(products);
    const matchedIds = new Set();
    const confirmationHTML = [];

    const visit = (value) => {
        if (Array.isArray(value)) {
            value.forEach(visit);
            return;
        }

        if (!value || typeof value !== "object") {
            return;
        }

        const productId = value.id?.toString();
        if (
            productId
            && purchasedIds.has(productId)
            && !matchedIds.has(productId)
            && value.confirmationHTML?.trim()
        ) {
            matchedIds.add(productId);
            confirmationHTML.push(value.confirmationHTML.trim());
        }

        Object.values(value).forEach(visit);
    };

    visit(pages);
    return confirmationHTML;
};

export const buildProductConfirmationHTML = (successHTML, pages, products) => {
    const baseHTML = successHTML || "";
    const matchingHTML = findPurchasedProductConfirmationHTML(pages, products)
        .map((confirmationHTML) => (
            `<div class="product-confirmation">${confirmationHTML}</div>`
        ))
        .join("\n");

    const productHTML = matchingHTML
        ? `<div class="product-confirmations">${matchingHTML}</div>`
        : "";

    if (baseHTML.includes(PRODUCT_CONFIRMATION_HTML_TOKEN)) {
        return baseHTML.split(PRODUCT_CONFIRMATION_HTML_TOKEN).join(productHTML);
    }

    return productHTML ? `${baseHTML}\n${productHTML}` : baseHTML;
};
